<template>
  <div class="work__content">
    <div
      class="work__media"
      v-for="(el, i) in medias"
      :data-media="i"
      :style="{
        'background-color': el?.background,
        'aspect-ratio':
          el?.image?.dimensions?.width / el?.image?.dimensions?.height,
      }"
      :class="{ 'is-boxed': el?.boxed }"
    >
      <AppMedia
        class="media"
        :src="el?.image?.url"
        :video="el?.video"
        :show-video-loader="Boolean(el?.video)"
      ></AppMedia>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  medias: { type: Array, default: [] },
});
</script>

<style lang="scss" scoped>
.work__content {
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
  margin-left: var(--offset);
  overflow: hidden;
  width: var(--col-4);

  @include mq(desktop) {
    padding-top: var(--top-offset);
    width: calc(var(--col-5) - var(--offset));
  }
}

.work__media {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  &.is-boxed {
    padding: 12%;
  }
}

.media {
  height: 100%;
  width: 100%;

  .is-boxed & {
    height: unset;
  }

  .is-boxed &:deep(video) {
    object-fit: contain;
  }
}
</style>
